import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import React from 'react';
import Home from "../../../Assets/Images/sampleChart.png";
import LeadershipChart from '../../Charts/LeadershipChart';

const styles = StyleSheet.create({
  page: {
    paddingHorizontal: 21,
    paddingVertical: 30,
    backgroundColor: '#FFFFFF',
    // justifyContent: "space-between",
    height: '100%'
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottom: '1px solid #00577D',
    paddingBottom: 5,
    marginBottom: 2,
    marginTop: '-15px'
  },
  headerleft: {

  },
  titlemain: {
    fontSize: 12,
    fontWeight: 700,
    color: '#76A3BE',
  },
  title: {
    fontSize: 11,
    fontWeight: 200,
    color: '#76A3BE',
  },
  rightsection: {
    alignItems: 'flex-end',
    flexDirection: 'column',
    flex: 1,
  },
  rightText: {
    fontSize: 8,
    textAlign: 'right',
    fontWeight: 700,
    color: '#76A3BE',
  },
  rightTextsybtext: {
    fontSize: 8,
    textAlign: 'right',
    fontWeight: 700,
    color: '#76A3BE',
  },
  section: {
    marginVertical: 10,
  },
  pageheading: {
    color: '#426B88',
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: 18,
    marginBottom:10
  },
  container: {
    flexDirection: 'row',
    marginTop:2,
    marginLeft: "0px",
    fontFamily: 'Lato',
  },
  containerrightsection: {
    marginLeft: 45,
    width: 315
  },
  image: {
    width: 243,
    alignSelf: 'center',
  },
  headertext: {
    fontSize: 14,
    fontWeight: 700,
    color: '#00577D',
    maxWidth: 198,
    marginBottom: 10,
    marginTop: 8
  },
  contentTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 10,
    textAlign: 'center',
  },
  paragraph: {
    fontSize: 12,
    textAlign: 'justify',
    fontWeight: 400,
    color: '#245775',
    marginBottom: 15,
    fontFamily: 'Lato',
  },
  footer: {
    width: 540,
    borderTop: '1px solid #00577D',
    paddingTop: 5,
    flexDirection: 'row',
    justifyContent: 'space-between',
    position: 'absolute',
    bottom: 15,
    left: 10,
    right: 21,
  },
  footersection: {
    flexDirection: 'column'
  },
  footerTextheading: {
    fontSize: 10,
    fontWeight: 700,
    fontFamily: 'Lato',
    color: '#76A3BE',
  },
  footerText: {
    fontSize: 8,
    fontFamily: 'Lato',
    fontWeight: 400,
    color: '#76A3BE',
  },
  justifystyle: {
    justifyContent: 'space-between',
    height:660
  },
  listItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 20,
  },
  index: {
    fontSize: 12,
    color: '#245775',
  },
  listText: {
    fontSize: 12,
    color: '#245775',
    flex: 1,
  },
});


const LeadershipPDF = () => {
  const quadrants = [
    { label: 'Strategic', value: 29, color: '#4A6FA5' },
    { label: 'Performance', value: 14, color: '#E0A458' },
    { label: 'Visionary', value: 22, color: '#3D85C6' },
    { label: 'Collaborative', value: 35, color: '#D9534F' },
  ];

  return (
    <View style={styles.page}>
      {/* Header */}
      <View style={styles.header}>
        <View style={styles.headerleft}>
          <Text style={styles.titlemain}>QUADRANT FLOW</Text>
          <Text style={styles.title}>Life & Leadership Assssment</Text>
        </View>
        <View style={styles.rightsection}>
          <Text style={styles.rightText}>Rob Murray</Text>
          <Text style={styles.rightTextsybtext}>Atlas Real Estate{"\n"}Oct 18, 2024</Text>
        </View>
      </View>

      <View style={styles.justifystyle}>
        {/* Content */}
        <View style={styles.section}>
          <Text style={styles.pageheading}>LEADERSHIP STYLE</Text>
          <Text style={styles.paragraph}>Quadrant Flow not only delineates your predominant leadership style, but it also provides a comprehensive framework for personal and professional growth. By understanding the distinct functions and attributes associated with each quadrant, leaders are equipped to enhance their self-awareness and adapt their approach to various situations.
          </Text>
          <Text style={styles.paragraph}>This methodology encourages leaders to explore how their unique attributes can be harmonized to maximize effectiveness, foster better team dynamics, and achieve organizational objectives. The holistic perspective offered by Quadrant Flow enables a deeper introspection into how one's leadership style impacts their environment, thereby facilitating a more balanced and strategic approach to leadership challenges.
          </Text>
          <Text style={styles.paragraph}>This exploration goes beyond merely identifying a primary leadership style; it involves examining the alignment—or potential misalignment—between your natural tendencies and the Quadrant Flow framework. Such an overlay offers valuable insights into the nuances of your leadership approach, revealing areas of strength as well as opportunities for improvement.
          </Text>
          <Text style={styles.paragraph}>By understanding where gaps exist between your current practices and the ideal quadrant attributes, you can initiate targeted development efforts. The goal is to foster a journey of continuous growth, where leaders not only understand who they are but also how they can evolve within the context of their roles and responsibilities.
          </Text>

        </View>

        {/* Graph */}
        <View>
          <Text style={styles.pageheading}>LEADERSHIP STYLE OVERVIEW CHART</Text>
          <View style={styles.container}>
            {/* <Image src={Home} style={styles.image} /> */}
            <LeadershipChart style={styles.image}/>
            <View style={styles.containerrightsection}>
              <Text style={styles.headertext}>STRONGEST {"\n"}CONFIRMATIONS AS A {"\n"}COLLABORATIVE LEADER</Text>

              <View style={styles.listItem}>
                <Text style={styles.index}>1. </Text>
                <Text style={styles.listText}>I am at my best when creating standardized processes that help others achieve their goals more easily.</Text>
              </View>

              <View style={styles.listItem}>
                <Text style={styles.index}>2. </Text>
                <Text style={styles.listText}>Effective strategy is primary.</Text>
              </View>

              <View style={styles.listItem}>
                <Text style={styles.index}>3. </Text>
                <Text style={styles.listText}>Success is contingent on thinking smarter.</Text>
              </View>
            </View>

          </View>
        </View>
        
      </View>


      {/* Footer Section */}

      <View style={styles.footer}>
        <View style={styles.footersection}>
          <Text style={styles.footerTextheading}>STRONGEST CONFIRMATIONS AS A COLLABORATIVE LEADER</Text>
          <Text style={styles.footerText}>© Copyright 2025 by Dr. Rob Murray & Jack Nicholson. Published by Transformational Performance & Transformed Leader. All rights reserved.</Text>
        </View>
        <Text style={styles.footerTextheading}>PAGE</Text>
      </View>
    </View>

  );
};

export default LeadershipPDF;
